import { Locale, type LocalizedString } from "../Locale.js";
import { SolutionGroup } from "../SolutionGroup.js";

export const solutionGroupNameMap = {
	[SolutionGroup.ByDesignation]: {
		[Locale.cs]: "Podle určení",
		[Locale.en]: "By designation",
	},
	[SolutionGroup.ByTechnology]: {
		[Locale.cs]: "Podle technologie",
		[Locale.en]: "By technology",
	},
	[SolutionGroup.ByIndustry]: {
		[Locale.cs]: "Podle průmyslového odvětví",
		[Locale.en]: "By industry sector",
	},
	[SolutionGroup.ByProduct]: {
		[Locale.cs]: "Podle typu produktu",
		[Locale.en]: "By product type",
	},
} satisfies Record<SolutionGroup, LocalizedString>;
